import { SessionContextProps } from "../../../../Context/SessionContext";
import { EnhancedAppointment } from "../../../../Models/Appointment";
import { EnhancedCustomer } from "../../../../Models/Customer";
import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import { IBaseDispositionConfirmationFormProps } from "../Components/ConfirmationModal/ConfirmationForm";
import MedicalEscalationConfirmationForm from "../Components/ConfirmationModal/MedicalEscalationConfirmationForm";
import SessionContextAppointmentPicker from "./SessionContextAppointmentPicker";

/** Build a function which accepts an appointment to escalate and opens a new window to the url to the appointment form
 * website with relevant query params.
 */
const getMedicalEscalationUrlConfirmedAction =
  (customer: EnhancedCustomer) =>
  (appointment: EnhancedAppointment): void => {
    window.open(
      `${process.env.REACT_APP_MEDICAL_ESCALATION_BASEURL}&PatientID=${customer.code}&PatientFirstName=${
        customer.firstName
      }&PatientLastName=${customer.lastName}&PatientPhone=${customer.phoneNumber}&Center=${
        customer.center?.name
      }&PatientZenotiRecord=${customer.externalId}&Surgeon=${appointment?.services
        .map(s => s.employeeEmail)
        .filter((v, i, s) => s.indexOf(v) === i)
        .join(", ")}&ProcedureDate=${appointment.startTime.toISODate()}&ProcedureType=${appointment.services
        .map(s => s.name)
        .join(", ")}`,
      "_blank"
    );
  };

type IContextProps = Pick<SessionContextProps, "customer">;

/** A {@link IMedicalEscalationForm} that has been provisioned with the medical escalation appointment picker.  */
const MedicalEscalationConfirmationFormWithPicker: React.FC<IContextProps & IBaseDispositionConfirmationFormProps> = ({
  customer,
  ...rest
}) =>
  MedicalEscalationConfirmationForm({
    ...rest,
    onConfirmed: getMedicalEscalationUrlConfirmedAction(customer),
    MedicalEscalationAppointmentPicker: SessionContextAppointmentPicker
  });

const SessionContextMedicalEscalationConfirmationForm: React.FC<IBaseDispositionConfirmationFormProps> =
  SessionContextValueProvider<IContextProps, IContextProps & IBaseDispositionConfirmationFormProps>({
    Component: MedicalEscalationConfirmationFormWithPicker,
    map: ({ customer }) => ({ customer })
  });

export default SessionContextMedicalEscalationConfirmationForm;
